// extracted by mini-css-extract-plugin
export default {"host":"Stripe_host__fZDs4","layout":"Stripe_layout__YCoyI","inner":"Stripe_inner__DcM54"};